<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-12">
                    <h3 class="mb-0 text-uppercase">{{ $t('cohorts.platform-cohorts') }}</h3>
                </div>
            </div>
        </div>

        <div>

            <base-alert type="secondary" class="mb-4 mx-3" v-if="!canEdit">
                <i class="fas fa-info-circle mr-1"></i>
                {{ $t('cohorts.edit-cohorts-in-meta-cohorts') }}
            </base-alert>

            <table-control :paging="ctrl.paging" :search="true" v-model="search" v-if="canEdit"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="visibleCohorts">

                <el-table-column>
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            <a href="#" @click.prevent="openLearners(row)">
                                {{ row.name }}
                            </a>
                        </h4>
                        <small>
                            {{ $t('common.learners') }}: {{ row.learners_count }}, 
                        </small>
                        <small>
                            {{ $t('common.instructors') }}: {{ row.instructors_count }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions" v-if="canEdit">
                    <template v-slot="{row}">

                        <button-checkbox button-classes="btn-secondary btn-sm mb-1 mt-1" class="d-inline"
                            :value="row.selected"
                            @change="toggleChild(row)"
                        >
                            {{ buttonLabel(row) }}
                        </button-checkbox>

                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="ctrl.paging" v-if="canEdit"></table-pagination>
        </div>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import CohortMapping from './CohortMapping'

    export default {

        props: {
            cohort: {
                type: Object,
                required: true
            },
        },

        data() {
            let mapping = new CohortMapping()
            return {
                loaded: false,
                mapping,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/cohorts',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    paging: {
                        perPage: 10,
                        total: 0
                    },
                    query: {
                        sort: ['name'],
                        accessors: ['learners_count', 'instructors_count'],
                        filters: {
                            is_child: true,
                        }
                    }
                }),
                search: '',
            }
        },

        created() {
            this.ctrl.mapData = this.mapData
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.$emit('ready')
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({name: {'$text': val}})
            },

            cohort(val) {
                this.ctrl.query.filters.owner_id = val.owner_id
                this.ctrl.rows.forEach(row => {
                    row.selected = this.isChild(row)
                });
            },
        },

        computed: {
            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            },

            canEdit() {
                return this.cohort.has_registrations == 0
            },

            visibleCohorts() {
                if (!this.canEdit) {
                    return this.ctrl.rows.filter(cohort => cohort.selected)
                }
                return this.ctrl.rows
            },
        },

        methods: {

            mapData(cohort) {
                let row = this.mapping.mapData(cohort)
                row.selected = this.isChild(cohort)
                return row
            },

            buttonLabel(cohort) {
                return cohort.selected
                    ? this.$t('common.unselect')
                    : this.$t('common.select')
            },

            isChild(cohort) {
                return this.cohort.children.find(child => child.id == cohort.id) != undefined
            },

            toggleChild(cohort) {
                const method = cohort.selected ? 'delete' : 'post'
                axios[method]('/astral/api/front/cohorts/'+this.$route.params.id+'/children/'+cohort.id)
                .then(resp => {
                    this.$emit('change');
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },

            openLearners(row) {
                this.$router.push({ name: 'admin-cohort', params: { id: row.id, role: 'learner' } })
            },
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }
    .card >>> .table-control form {
        width: 100%;
    }
    
</style>
